














import { SelectOption } from "@/data/models/select-option.model";
import { AnagraficaService } from "@/data/services/anagrafica.service";
import { Component, Inject, Vue } from "vue-property-decorator";
import AnagraficaList from "@/packages/albo/anagrafica/AnagraficaList.vue";
import packageInfo from "../../../package.json";

@Component({
  components: {
    AnagraficaList,
  },
})
export default class ElencoDetail extends Vue {
  @Inject("AnagraficaService") anagraficaService!: AnagraficaService;

  elenco!: SelectOption;

  loading = true;
  showtitle = false;
  albourl: string = "";
  //
  loadElenco(id: number) {
    this.anagraficaService
      .getMenu("elenco")
      .then((result) => {
        const elenchi: SelectOption[] = result;
        const e = elenchi.find((e: SelectOption) => e.value === id + "");
        if (e) {
          this.elenco = e;
        }
      })
      .finally(() => (this.loading = false));
  }

  beforeMount() {
    console.log(`UI v. ${packageInfo.version}`);
  }

  mounted() {
    this.albourl = this.$el.parentElement?.getAttribute("data-albo") || "";
    const eid = this.$el.parentElement?.getAttribute("data-id");
    let id = undefined;
    if (!eid) {
      const uri = window.location.search.substring(1);
      const params = new URLSearchParams(uri);
      id = params.get("id");
      this.showtitle = true;
    } else {
      id = eid;
      this.showtitle = false;
    }
    if (id) {
      this.loadElenco(+id);
    }
  }
}
